import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'subaccounts/components/list/SubaccountsActions';

const SubaccountsListRow = ({ subaccount, company, subcompany, permissions, t, handleToggle }) => {
  return (
    <tr>
      <td>{subaccount.key}</td>
      <td>{subaccount.name}</td>
      <td>{subaccount.description}</td>
      <td>{subaccount.parent.name}</td>
      <td className="text-center">{t(subaccount.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          subaccount={subaccount}
          company={company}
          subcompany={subcompany}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(SubaccountsListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/list/SubaccountsListRow.js